import { ArrowDownIcon } from "@cmp-src/icons/icons";
import {
  DivisionSelector,
  DivisionSelectorProps
} from "@cmp-src/divisions/DivisionSelector/DivisionSelector";
import React from "react";

export const MobileDivisionSelector: React.FC<DivisionSelectorProps> = (
  props
) => {
  return (
    <DivisionSelector
      trigger={
        <div className="flex items-center gap-2">
          <span className="flex-1 min-w-0 font-bold text-[18px] max-w-[200px] truncate">
            {props.selectedOffice?.name}{" "}
          </span>
          <ArrowDownIcon className={"size-4 transition-opacity shrink-0"} />
        </div>
      }
      {...props}
    />
  );
};
